import * as React from 'react';
import type { FormikErrors, FormikTouched} from 'formik';
import { Field } from 'formik';
import { PupilFormType } from '../../../containers/pupil-details/PupilDetails';
import { FieldRow } from '../../field-row/FieldRow';
import type { PupilValues } from '../CustomerDetailsForm';
import { FieldValidation } from '../../field-validation/FieldValidation';
import './TermsFields.css';

export interface Props {
  values: PupilValues;
  errors: FormikErrors<PupilValues>;
  touched: FormikTouched<PupilValues>;
  formType?: PupilFormType;
  // tslint:disable-next-line:no-any
  setFieldRef?: (field: string, node: any) => void;
}

export class TermsFields extends React.PureComponent<Props> {
  render() {
      const { values, touched, errors, formType} = this.props;
      return (
          <div data-testid="terms-fields">
            <h3>Before you proceed</h3>
              <hr className="a-keyline-divider--horizontal-solid-light" />
              <FieldRow className="conditions-container">
                  {formType === PupilFormType.Pupil &&
                      <FieldRow
                          touched={touched.marketingConsent}
                          error={!!errors.marketingConsent}
                      >
                          <FieldValidation
                              touched={touched.marketingConsent}
                              errMessage={errors.marketingConsent}
                          />
                          <div data-testid="marketing-consent" className="m-form-row__content">
                              <span style={{ fontWeight: 600 }}>
                                  Don't miss out on helpful information, offers & competitions!
                              </span>
                              <p>
                              Aviva Driving School would like to send you helpful information, offers and competitions
                              run by Aviva and associated third parties by phone, post, e-mail or text. We will use
                              your consent for a maximum period of 12 months. You can withdraw your consent at any time,
                              there's no disadvantage in doing so, you just need to let us know.
                              </p>
                              <label className="a-checkbox" htmlFor="marketingConsent">
                                  <Field
                                      name="pupil.marketingConsent"
                                      type="checkbox"
                                      className="a-checkbox__input"
                                      id="marketingConsent"
                                      checked={values.marketingConsent}
                                  />
                                  <span className="a-checkbox__label">
                                      <span className="a-checkbox__label-inner">
                                          I would like to receive such information
                                      </span>
                                  </span>
                                  <span className="a-checkbox__ui" />
                              </label>
                          </div>
                      </FieldRow>
                  }
                  {formType === PupilFormType.Pupil &&
                      <hr className="a-keyline-divider a-keyline-divider--horizontal-dashed" />
                  }
                  <FieldRow
                      touched={touched.termConditionsConsent}
                      error={!!errors.termConditionsConsent}
                  >
                      <FieldValidation
                          touched={touched.termConditionsConsent}
                          errMessage={errors.termConditionsConsent}
                      />
                      <div data-testid="terms-and-conditions" className="m-form-row__content">
                          <p>
                              By agreeing you are confirming that you have read and
                              understood our terms and conditions and agree to be bound by them.<br />
                              <a href="http://www.aviva.ie/driving-school/terms/" target="_blank" rel="noopener noreferrer">
                                  Terms & Conditions
                              </a>
                          </p>
                          <label className="a-checkbox" htmlFor="termConditionsConsent">
                              <Field
                                  name="pupil.termConditionsConsent"
                                  type="checkbox"
                                  className="a-checkbox__input"
                                  id="termConditionsConsent"
                                  checked={values.termConditionsConsent}
                              />
                              <span className="a-checkbox__label">
                                  <span className="a-checkbox__label-inner">
                                      I agree to the terms and conditions of Aviva Driving School
                                  </span>
                              </span>
                              <span className="a-checkbox__ui" />
                          </label>
                      </div>
                  </FieldRow>
              </FieldRow>
            </div>
        );
    }
}